// A week, stepped or picked (B-418): the arrows a week at a time, and between
// them the week itself as a menu of every week there is, so week 3 from week
// 14 is one choice rather than eleven presses. Recap and Awards (the audit of
// 2026-10-17, item 17).

import { Choice, IconButton } from '../../kit/ui';

export function WeekStepper({
  periods,
  current,
  label,
  onGo,
}: {
  /** The weeks there are, in order: the read's own list. */
  periods: readonly number[];
  current: number;
  /** The current week's name, the league's own ("Week 5"). */
  label: string;
  onGo: (period: number) => void;
}) {
  const idx = periods.indexOf(current);
  const prev = idx > 0 ? periods[idx - 1]! : null;
  const next = idx >= 0 && idx < periods.length - 1 ? periods[idx + 1]! : null;
  const weeks = idx >= 0 ? periods : [...periods, current].sort((a, b) => a - b);
  return (
    <div className="fsp-awards-stepper">
      <IconButton
        icon="previous"
        label="Previous week"
        variant="quiet"
        disabled={prev === null}
        onClick={() => prev !== null && onGo(prev)}
      />
      <span className="fsp-week-pick">
        <Choice
          label="Week"
          hideLabel
          searchable={false}
          required
          value={String(current)}
          onChange={(v) => {
            if (v && Number(v) !== current) onGo(Number(v));
          }}
          // The weeks by their number; the one on screen by its own name.
          options={weeks.map((p) => ({
            value: String(p),
            label: p === current ? label : `Week ${p}`,
          }))}
        />
      </span>
      <IconButton
        icon="next"
        label="Next week"
        variant="quiet"
        disabled={next === null}
        onClick={() => next !== null && onGo(next)}
      />
    </div>
  );
}
